import { Component, OnInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { MainService } from '../main.service';
import { Permiso } from '../commons/interfaces/permiso.interface';
import { Router } from '@angular/router';

declare const $: any;

//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [
    {
        path: '/admin/dashboard',
        title: 'Dashboard',
        type: 'link',
        icontype: 'dashboard'
    }, {
        path: '/admin/descargas',
        title: 'Reporte de Descargas',
        type: 'link',
        icontype: 'download'
    }, {
        path: '/admin',
        title: 'Administrar',
        type: 'sub',
        icontype: 'settings',
        collapse: 'admin',
        children: [
            {
                path: 'perfiles',
                title: 'Perfiles',
                ab: 'AD'
            },
            {
                path: 'categorias',
                title: 'Categorias',
                ab: 'CA'
            },
            {
                path: 'reciclaje',
                title: 'Papelera',
                ab: 'PP'
            }
        ]
    }, {
        path: '/reportes',
        title: 'Reportes',
        type: 'sub',
        icontype: 'analytics',
        collapse: 'reportes',
        children: [
            {
                path: 'recursosvistas',
                title: 'Vistas por Recurso',
                ab: 'RV'
            }, {
                path: 'recursosdescargas',
                title: 'Descargas por Recurso',
                ab: 'RD'
            }, {
                path: 'apisconsumo',
                title: 'Apis Consumidas',
                ab: 'AC'
            }, {
                path: 'transferencia',
                title: 'Transferencia Datos',
                ab: 'TD'
            }, {
                path: 'recursosfrecuencia',
                title: 'Actualización Recursos',
                ab: 'AR'
            }, {
                path: 'actualizacionfrecuencia',
                title: 'Frecuencia Actualización',
                ab: 'FA'
            }, {
                path: 'recursosinventario',
                title: 'Inventario de Recursos',
                ab: 'IV'
            }
        ]
    },{
        path: '/portaldatosabiertos',
        title: 'Portal de Datos Abiertos',
        type: 'sub',
        icontype: 'content_paste',
        collapse: 'PDA',
        children : [
            {
                path: 'recursos',
                title: ' Recursos',
                ab: 'RE'
            }
        ] 


    }

    // ,{
    //     path: '/components',
    //     title: 'Components',
    //     type: 'sub',
    //     icontype: 'apps',
    //     collapse: 'components',
    //     children: [
    //         {path: 'buttons', title: 'Buttons', ab:'B'},
    //         {path: 'grid', title: 'Grid System', ab:'GS'},
    //         {path: 'panels', title: 'Panels', ab:'P'},
    //         {path: 'sweet-alert', title: 'Sweet Alert', ab:'SA'},
    //         {path: 'notifications', title: 'Notifications', ab:'N'},
    //         {path: 'icons', title: 'Icons', ab:'I'},
    //         {path: 'typography', title: 'Typography', ab:'T'}
    //     ]
    // },{
    //     path: '/forms',
    //     title: 'Forms',
    //     type: 'sub',
    //     icontype: 'content_paste',
    //     collapse: 'forms',
    //     children: [
    //         {path: 'regular', title: 'Regular Forms', ab:'RF'},
    //         {path: 'extended', title: 'Extended Forms', ab:'EF'},
    //         {path: 'validation', title: 'Validation Forms', ab:'VF'},
    //         {path: 'wizard', title: 'Wizard', ab:'W'}
    //     ]
    // },{
    //     path: '/tables',
    //     title: 'Tables',
    //     type: 'sub',
    //     icontype: 'grid_on',
    //     collapse: 'tables',
    //     children: [
    //         {path: 'regular', title: 'Regular Tables', ab:'RT'},
    //         {path: 'extended', title: 'Extended Tables', ab:'ET'},
    //         {path: 'datatables.net', title: 'Datatables.net', ab:'DT'}
    //     ]
    // },{
    //     path: '/maps',
    //     title: 'Maps',
    //     type: 'sub',
    //     icontype: 'place',
    //     collapse: 'maps',
    //     children: [
    //         {path: 'google', title: 'Google Maps', ab:'GM'},
    //         {path: 'fullscreen', title: 'Full Screen Map', ab:'FSM'},
    //         {path: 'vector', title: 'Vector Map', ab:'VM'}
    //     ]
    // },{
    //     path: '/widgets',
    //     title: 'Widgets',
    //     type: 'link',
    //     icontype: 'widgets'

    // },{
    //     path: '/charts',
    //     title: 'Charts',
    //     type: 'link',
    //     icontype: 'timeline'

    // },{
    //     path: '/calendar',
    //     title: 'Calendar',
    //     type: 'link',
    //     icontype: 'date_range'
    // },{
    //     path: '/pages',
    //     title: 'Pages',
    //     type: 'sub',
    //     icontype: 'image',
    //     collapse: 'pages',
    //     children: [
    //         {path: 'pricing', title: 'Pricing', ab:'P'},
    //         {path: 'timeline', title: 'Timeline Page', ab:'TP'},
    //         {path: 'login', title: 'Login Page', ab:'LP'},
    //         {path: 'register', title: 'Register Page', ab:'RP'},
    //         {path: 'lock', title: 'Lock Screen Page', ab:'LSP'},
    //         {path: 'user', title: 'User Page', ab:'UP'}
    //     ]
    // }
];
@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[] = [];
    ps: any;
    constructor(
        public mainService: MainService,
        private router: Router
    ){
    }
    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    ngOnInit() {
        this.menuItems = ROUTES.filter(menuItem => menuItem);
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            this.ps = new PerfectScrollbar(elemSidebar);
        }
    }
    updatePS(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            this.ps.update();
        }
    }
    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
    expandOrCollapseMenu(id: any) {
        let parent = document.getElementById(id + "-p");
        let child = document.getElementById(id);
        if ( parent ) {
            parent.ariaExpanded = parent?.ariaExpanded === "true" ? "false" : "true";
        }
        if ( child ) {
            child.style.height = child?.style.height === "0px" || child?.style.height === "" ? "100%" : "0";
        }
    }
    cerrarSesion(){
        this.mainService.fLogOut();
       
    }
}
